import { h, Component } from 'preact';
import { BaseComponent } from "../../common/BaseComponent";

import List from 'preact-material-components/List';
import TextField from 'preact-material-components/TextField';
import Button from 'preact-material-components/Button';

import { bind } from 'decko';
import { route } from 'preact-router';
import { ISettingsState } from './ISettings';
import { Company } from '../../models/Company';

let style = require('./style.scss');

export class SettingsComponent extends BaseComponent<any, ISettingsState> {

    constructor(props, ctx) {
        super(props, ctx);
        //this.state.companies = [{ name: "Loading...", code: "" }];
    }

    componentDidMount() {
        this.loadCompanies();
    }

    public loadCompanies() {
        this.modal.showLoader(this.authService.getUserCompanies())
            .then((c) => {
                if (c.errorMessage) {
                    this.modal.alert(c.errorMessage);
                    return;
                }
                this.setState({ companies: c.result });
            }).catch((e) => {
                this.modal.alert(e.errorMessage || e);
            })
    }

    @bind
    public onAddCompany() {
        this.modal.showLoader(this.authService.addUserCompany(this.state.addCompany))
            .then((r) => {
                if (r.errorMessage) {
                    this.modal.alert(r.errorMessage);
                    return;
                }
                //this.setState({ companies: [{ name: "Loading...", code: "" }] });
                this.loadCompanies();
            }).catch((e) => {
                this.modal.alert(e.errorMessage || e);
            })
    }

    @bind
    public onRemoveCompany(company: Company) {
        this.modal.confirmation(`Remove yourself from Company ${company.name}?`, () => {
            this.modal.showLoader(this.authService.removeUserCompany(company.code))
                .then((r) => {
                    if (r.errorMessage) {
                        this.modal.alert(r.errorMessage);
                    }
                    this.loadCompanies();
                }).catch((e) => {
                    this.modal.alert(e.errorMessage || e);
                    this.loadCompanies();
                });
        });
    }

    render(props?: any, state?: any, context?: any): JSX.Element {
        return <div>
            <List>
                {this.state.companies ? this.state.companies.map((c) => <span>
                    <List.Item onClick={() => this.onRemoveCompany(c)}>{c.name} - {c.code}</List.Item>
                    <List.Divider />
                </span>
                ) : ""}
            </List>

            <div class={style.formField}>
                <TextField id="addCompany" name="addCompany" label="Add Company Code" value={this.state.addCompany} onInput={(e: any) => this.setState({ addCompany: e.target.value })} />
            </div>
            <div class={style.formField}>
                <Button raised ripple onClick={this.onAddCompany}>Add</Button>
            </div>
        </div>
    }
}


// WEBPACK FOOTER //
// ./routes/settings/settings.tsx